// src/components/PublicLayout.js
import React from 'react';
import { Container, Row, Col, Nav, Navbar, Offcanvas, Image } from 'react-bootstrap';

function PublicLayout({ children }) {
  return (
    <Container>
      <Row>
      <Col md={12} className="mb-1">
      {children}
      </Col>
      </Row>
    </Container>
  );
}

export default PublicLayout;
